/**
 * Application constants for hardware drivers and runtime configuration.
 */

/** Ingenico TPE serial protocol constants. */
export const TPE = {
  ENQ: 0x05,
  ACK: 0x06,
  NAK: 0x15,
  STX: 0x02,
  ETX: 0x03,
  EOT: 0x04,
  BAUD_RATE: 9600,
  /** Max wait for initial ENQ/ACK handshake (ms). */
  HANDSHAKE_TIMEOUT: 2000,
  /** Max wait for a single dialogue exchange (ms). */
  DIALOGUE_TIMEOUT: 70000,
  /** Absolute max for the entire transaction (ms). */
  FATAL_TIMEOUT: 200000,
  /** Delay before sending a frame after receiving ACK (ms). */
  PRE_SEND_DELAY: 50,
  /** Serial port polling interval (ms). */
  POLL_INTERVAL: 10,
} as const;

/** Star TSP143IV USB thermal printer constants. */
export const PRINTER = {
  VENDOR_ID: 0x0519,
  PRODUCT_ID: 0x0001,
  /** Max bytes per USB bulk transfer. */
  CHUNK_SIZE: 4096,
  /** Delay between chunks to avoid buffer overflow (ms). */
  CHUNK_DELAY: 10,
} as const;

/** General application timing and retry constants. */
export const APP = {
  /** WebSocket heartbeat interval (ms). */
  HEARTBEAT_INTERVAL: 10000,
  /** How often to refresh product catalog from API (ms). */
  PRODUCT_REFRESH_INTERVAL: 60000,
  /** Offline queue sync interval (ms). */
  SYNC_INTERVAL: 30000,
  /** HTTP request timeout (ms). */
  API_TIMEOUT: 5000,
  /** Maximum number of retry attempts. */
  MAX_RETRIES: 3,
  /** Progressive backoff delays between retries (ms). */
  RETRY_DELAYS: [1000, 2000, 5000, 10000, 30000],
  /** Inactivity timeout before returning to attract screen (seconds). */
  INACTIVITY_TIMEOUT: 30,
  /** Polling interval to check for print data after payment (ms). */
  PRINT_DATA_POLL_INTERVAL: 2000,
  /** Max polling attempts before giving up on print data. */
  PRINT_DATA_MAX_ATTEMPTS: 15,
} as const;
